// When adding a new CHANNEL make sure that the FILTERS on Ticket List are correct.
export var Channel;
(function (Channel) {
    Channel[Channel["WEB"] = 100] = "WEB";
    Channel[Channel["EMAIL"] = 110] = "EMAIL";
    Channel[Channel["PHONE_CALLBACK"] = 120] = "PHONE_CALLBACK";
    Channel[Channel["PHONE_OUTBOUND"] = 121] = "PHONE_OUTBOUND";
    Channel[Channel["PHONE_INBOUND"] = 122] = "PHONE_INBOUND";
    Channel[Channel["OUTBOUND"] = 130] = "OUTBOUND";
    Channel[Channel["FACEBOOK"] = 140] = "FACEBOOK";
    Channel[Channel["WHATSAPP"] = 150] = "WHATSAPP";
    Channel[Channel["CHAT"] = 160] = "CHAT";
    Channel[Channel["CHAT_OUTBOUND"] = 161] = "CHAT_OUTBOUND";
    Channel[Channel["WIDGET"] = 170] = "WIDGET";
    Channel[Channel["API"] = 180] = "API";
    Channel[Channel["SMS_INBOUND"] = 190] = "SMS_INBOUND";
    Channel[Channel["SMS_OUTBOUND"] = 200] = "SMS_OUTBOUND";
})(Channel || (Channel = {}));
//# sourceMappingURL=channel.enum.js.map